export default {
  saveInfo: { id: 'save_info' },
  order: { id: 'order_number' },
  refreshInterval: { id: 'refresh_interval' },
  refreshTriggerInterval: { id: 'refresh_trigger_interval' },
  slug: { id: 'slug' },
  name: { id: 'name' },
  application: { id: 'application' },
  embedLink: { id: 'embed_link' },
  parameters: { id: 'parameters' },
}
